import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdVerifiedDomains = "/companies/:company_id/verified_domains";

export const postCompaniesCompanyIdVerifiedDomainsCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdVerifiedDomains,
];
